import React, { useState,useEffect, Fragment } from "react";
import ListControl from "../components/listControl/ListControl";
import Upload from "./Upload";
import ZappBar from "../components/zappBar/ZappBar";
import Dialogs from "../components/dialogs/Dialogs";
//redux
import {useSelector} from 'react-redux' //get from redux 


const Home = (props) => {
  const user = useSelector((state)=>state.user.value)
  //const [exhibitor, setExhibitor] = useState("");
  const [dialogReloadOpen, setDialogReloadOpen] = useState(false);
  const [dialogAppExitOpen, setDialogAppExitOpen] = useState(false);
  const [onLine, setOnLine] = useState(true);
  const pollOnline = () => {
    setOnLine(navigator.onLine);
  };
  // initial call, or just call refresh directly
  setTimeout(pollOnline, 5000);

  useEffect(() => {
    //if (props.exhibit != null) {
    //    setExhibitor(props.exhibit);
    //  }
  }, []) ; /* eslint-disable-line react-hooks/exhaustive-deps*/

  return (
    <Fragment>
      <ZappBar 
        onLine={onLine}
        setDialogReloadOpen={setDialogReloadOpen}
        setDialogAppExitOpen={setDialogAppExitOpen}
      />
      {user === "admin" ? (
        /* Admin Logged In View */
        <Upload />
      ) : (
        /* Attendee Logged In View */
        <ListControl
          //handleExhibitorChange={handleExhibitorChange}
          //exhibitor={exhibitor}
        />
      )}
        <Dialogs
            dialogReloadOpen = {dialogReloadOpen}
            dialogAppExitOpen={dialogAppExitOpen}
            setDialogReloadOpen={setDialogReloadOpen}
            setDialogAppExitOpen={setDialogAppExitOpen}
            handleSignOut={props.handleSignOut}
        />
    </Fragment>
  );
};

export default Home;
